/**
 * Bundles - list
 */

// React
import React from 'react';

//UI
import {
  withStyles,
  Theme,
  createStyles,
  makeStyles,
} from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Badge,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {mdiCart} from '@mdi/js';

// Helper
import {translateBundleStatus} from '../../utils/helpers';

// Type
import {Bundles} from '../bundles/interfaces';
type Props = {
  data: Bundles;
};

// Style
const StyledBadge = withStyles((theme: Theme) =>
  createStyles({
    badge: {
      right: -3,
      top: 13,
      border: `2px solid ${theme.palette.background.paper}`,
      padding: '0 4px',
    },
  })
)(Badge);

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  })
)(TableCell);

const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      '&:nth-of-type(even)': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);
const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
});

// Const
const cols = [
  'نام راننده',
  'شناسه بسته',
  'تعداد سفارش',
  'مرکز سفارش',
  'بازه زمانی تحویل',
  'وضعیت بسته',
];

export default function List(props: Props) {
  const classes = useStyles();

  const {data} = props;
  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="customized table">
        <TableHead>
          <TableRow>
            {cols.map((value, index) => (
              <StyledTableCell align="center" key={index}>
                {value}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        {
          <TableBody>
            {data.map((item, index) => {
              return (
                <StyledTableRow key={item.id}>
                  <StyledTableCell component="th" align="center" scope="row">
                    {item.driverName}
                  </StyledTableCell>
                  <StyledTableCell align="center">{item.id}</StyledTableCell>
                  <StyledTableCell align="center">
                    <StyledBadge
                      badgeContent={item.ordersCount}
                      color="secondary"
                      showZero
                    >
                      <Icon path={mdiCart} size={1} />
                    </StyledBadge>
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {item.centerName}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {item.deliveryEndTime} - {item.deliveryStartTime}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {translateBundleStatus(item.status)}
                  </StyledTableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
        }
      </Table>
    </TableContainer>
  );
}
